import React from 'react';
import direction from '../../styles/direction.module.scss';
import {isValidTimeSum, getRawTimeSum} from '../../utils/time';
import {StringInputProps} from './StringInput';

export const TimeSumInput = ({
    column,
    inputRef,
    value,
    isReadonly,
    handleMouseDown,
    handleKeyDown,
    handleChange,
    searchMode,
    onFocus,
    onBlur
}: StringInputProps) => {
    const isValidDateTime = (value: string) => {
        if (searchMode) {
            return true;
        }
        return isValidTimeSum(value);
    };

    const validateAndChange = event => {
        const newValue: string = event.target.value;
        if (column.editMode) {
            handleChange(newValue);
        } else {
            const rawDate = getRawTimeSum(newValue, value);
            (searchMode || isValidDateTime(rawDate)) && handleChange(rawDate);
        }
    };

    return (
        <input
            type={'text'}
            maxLength={column.maxLength}
            ref={inputRef}
            value={value}
            onKeyDown={handleKeyDown}
            onChange={validateAndChange}
            readOnly={isReadonly}
            onMouseDown={handleMouseDown}
            className={direction.ltrDirection}
            onFocus={onFocus}
            onBlur={onBlur}
        />
    );
};
